
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconMessageSelector = "fhi-icon-message";

/**
 * ## FhiIconMessage
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-message
 * @element fhi-icon-message
 */
@customElement(FhiIconMessageSelector)
export class FhiIconMessage extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M6.266 4.112a9.75 9.75 0 0 1 12.636.985 9.752 9.752 0 0 1-4.638 16.38 9.75 9.75 0 0 1-6.416-.669L2.241 22.71a.75.75 0 0 1-.951-.95l1.9-5.61a9.75 9.75 0 0 1-.668-6.414 9.75 9.75 0 0 1 3.744-5.623m6.383-.345a8.251 8.251 0 0 0-7.982 11.99.75.75 0 0 1 .042.583l-1.512 4.461 4.462-1.511.073-.02a.75.75 0 0 1 .51.063 8.252 8.252 0 0 0 9.6-13.175 8.25 8.25 0 0 0-5.193-2.39"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
